
import { Modal, Button } from '@cb/apricot-react';
import {  FC} from 'react';

export interface TimeoutWarningModalProps {
  isOpen?: boolean;
  onConfirm: VoidFunction;
  onClose: VoidFunction;
}
// @ts-ignore
 export const TimeoutWarningModal: FC<TimeoutWarningModalProps> = ({ isOpen,  onConfirm, onClose}) => {

  return (
    // @ts-ignore
    <Modal
      title="Session Timeout"
      actions={[
        <Button onClick={onConfirm} >
          Log off
        </Button>,
        <Button  onClick={onClose}>
          Stay Logged In
        </Button>,
      ]}
      open={isOpen}
      closeButton={false}
      escClose={false}
      withHeader={false}
      >
        <div> <strong>Session Timeout</strong></div> <br/>
        <div>You're being timed out due to inactivity. Please choose to stay signed in or to log off. Otherwise, you will be logged off automatically</div>
        <br />
      </Modal>
);
};
